import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import localeFrExtra from '@angular/common/locales/extra/fr'
import localeFr from '@angular/common/locales/fr'
import {ApplicationConfig} from '@angular/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {
  provideRouter,
  withHashLocation,
  withInMemoryScrolling
} from '@angular/router'
import {authInterceptor} from '@sparbanken-syd/sparbanken-syd-bankid'

import {routes} from './app.routes'
import {WINDOW} from './application/app'

registerLocaleData(localeFr, 'fr', localeFrExtra)
export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    {provide: WINDOW, useValue: window},
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withInterceptors([
        authInterceptor
      ])
    )
  ]
}